import { render, staticRenderFns } from "./CurrencyInputField.vue?vue&type=template&id=10625aab"
import script from "./CurrencyInputField.vue?vue&type=script&lang=js"
export * from "./CurrencyInputField.vue?vue&type=script&lang=js"
import style0 from "./CurrencyInputField.vue?vue&type=style&index=0&id=10625aab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports